// Central API configuration
// In development, Vite proxy handles routing (requests go to same origin)
// In production, set VITE_API_URL to your deployed API URL

export const API_BASE = import.meta.env.VITE_API_URL || '/api';

export function apiUrl(path: string): string {
  return `${API_BASE}${path}`;
}
